export default __webpack_public_path__ + "static/media/select-all.c23d364c.svg";